export { Returns as default, getStaticProps } from '@cinch-nx/feature-returns'
